import(/* webpackMode: "eager" */ "/codebuild/output/src1763303803/src/build-ecommerce-frontend/src/app/loading.js");
